export default __webpack_public_path__ + "static/media/ICCT TDS.393d8ade.pdf";